module.exports = __webpack_public_path__ + "img/suanlidiaodu2.088b558a.png";